<template>
  <div class="app-container pb-50px">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="公众号配置" name="settings">
        <el-card v-loading="settingsLoading" shadow="never">
          <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            size="small"
            label-width="150px"
          >
            <el-form-item label="启用状态">
              <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
            <el-form-item label="公众号名称" prop="name">
              <el-input v-model="form.name" class="form-input"></el-input>
            </el-form-item>
            <el-form-item label="发送通道" prop="provider">
              <el-radio-group v-model="form.provider">
                <el-radio-button label="direct_wechat"
                  >直连微信</el-radio-button
                >
                <el-radio-button label="bridge">中转平台</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="isDirectProvider" label="AppID" prop="app_id">
              <el-input v-model="form.app_id" class="form-input"></el-input>
            </el-form-item>
            <el-form-item v-if="isDirectProvider" label="AppSecret">
              <el-input
                v-model="form.app_secret"
                class="form-input"
                show-password
                :placeholder="form.app_secret_masked || '请输入AppSecret'"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="isDirectProvider"
              label="回调Token"
              prop="token"
            >
              <el-input
                v-model="form.token"
                class="form-input"
                placeholder="填写公众号平台消息推送配置里的Token"
              ></el-input>
              <div class="form-tips">
                Token不是服务器地址。本地隧道调试时，公众号平台服务器地址填写：公网域名
                + /wechat/callback
              </div>
            </el-form-item>
            <el-form-item v-if="isDirectProvider" label="EncodingAESKey">
              <el-input
                v-model="form.encoding_aes_key"
                class="form-input"
                placeholder="明文模式可不填，兼容模式/安全模式再填写"
              ></el-input>
              <div class="form-tips">
                当前回调按明文模式、XML格式处理；EncodingAESKey暂不参与解密。
              </div>
            </el-form-item>
            <el-form-item label="模板ID" prop="template_id">
              <el-input
                v-model="form.template_id"
                class="form-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="模板字段">
              <el-row :gutter="10" class="field-map">
                <el-col :span="6">
                  <el-input v-model="form.template_field_map.remind_time">
                    <template slot="prepend">提醒时间</template>
                  </el-input>
                </el-col>
                <el-col :span="6">
                  <el-input v-model="form.template_field_map.contact">
                    <template slot="prepend">联系方式</template>
                  </el-input>
                </el-col>
                <el-col :span="6">
                  <el-input v-model="form.template_field_map.country">
                    <template slot="prepend">客户国家</template>
                  </el-input>
                </el-col>
                <el-col :span="6">
                  <el-input v-model="form.template_field_map.reason">
                    <template slot="prepend">跟进原因</template>
                  </el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item
              v-if="isBridgeProvider"
              label="中转地址"
              prop="bridge_endpoint"
            >
              <el-input
                v-model="form.bridge_endpoint"
                class="form-input"
                placeholder="中转平台规划完成后填写"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isBridgeProvider" label="中台AppCode">
              <el-input
                v-model="form.bridge_app_code"
                class="form-input"
                placeholder="lead_system"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isBridgeProvider" label="中台AppSecret">
              <el-input
                v-model="form.bridge_app_secret"
                class="form-input"
                show-password
                :placeholder="
                  form.bridge_app_secret_masked || '请输入中台应用密钥'
                "
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isBridgeProvider" label="兼容Token">
              <el-input
                v-model="form.bridge_token"
                class="form-input"
                show-password
                :placeholder="
                  form.bridge_token_masked ||
                  '旧字段兼容，优先使用中台AppSecret'
                "
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="actions">
            <el-button
              v-if="$hasPermission('setting.wechat', 'edit')"
              type="primary"
              size="small"
              :loading="saving"
              @click="saveSettings"
            >
              保存配置
            </el-button>
            <el-button
              v-if="
                isDirectProvider && $hasPermission('setting.wechat', 'test')
              "
              size="small"
              @click="testToken"
            >
              测试AccessToken
            </el-button>
            <el-button
              v-if="$hasPermission('setting.wechat', 'test')"
              size="small"
              @click="openTestDialog"
            >
              测试模板消息
            </el-button>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="绑定接收人" name="bindings">
        <el-card shadow="never">
          <el-form inline size="small" :model="bindingQuery">
            <el-form-item>
              <el-input
                v-model="bindingQuery.keyword"
                placeholder="客户、备注或openid"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="站点">
              <el-select
                v-model="bindingQuery.site_id"
                class="site-select"
                filterable
                clearable
                placeholder="全部站点"
              >
                <el-option label="全部站点" value=""></el-option>
                <el-option
                  v-for="site in siteOptions"
                  :key="site.id"
                  :label="siteOptionLabel(site)"
                  :value="site.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getBindings">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="bindingsLoading"
            :data="bindings.list"
            size="small"
          >
            <el-table-column
              prop="customer_account_id"
              label="子账户ID"
              width="95"
            ></el-table-column>
            <el-table-column
              prop="customer_name"
              label="客户"
              min-width="140"
            ></el-table-column>
            <el-table-column
              prop="username"
              label="账号"
              min-width="120"
            ></el-table-column>
            <el-table-column label="站点" min-width="220">
              <template slot-scope="{ row }">
                <div class="site-info">
                  <div class="site-name">{{ row.site_name || "-" }}</div>
                  <div class="site-url">{{ row.site_url || "-" }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="openid_masked"
              label="OpenID"
              min-width="160"
            ></el-table-column>
            <el-table-column label="微信接收人" min-width="180">
              <template slot-scope="{ row }">
                <div class="wechat-user">
                  <img
                    class="wechat-avatar"
                    :src="row.avatar_url || defaultWechatAvatar"
                    alt="微信头像"
                  />
                  <div>
                    <div class="wechat-name">
                      {{ row.nickname || "微信接收人" }}
                    </div>
                    <div class="wechat-openid">
                      {{ row.openid_masked || "-" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              min-width="120"
            ></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="{ row }">
                <el-tag v-if="row.status === 1" size="mini">有效</el-tag>
                <el-tag v-else size="mini" type="info">已解绑</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="关注" width="100">
              <template slot-scope="{ row }">
                <el-tag v-if="row.subscribe_status === 1" size="mini"
                  >已关注</el-tag
                >
                <el-tag v-else size="mini" type="warning">未关注</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="绑定时间" width="170">
              <template slot-scope="{ row }">{{
                timeText(row.bound_at)
              }}</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="通知日志" name="logs">
        <el-card shadow="never">
          <el-form inline size="small" :model="notificationQuery">
            <el-form-item>
              <el-select
                v-model="notificationQuery.status"
                clearable
                placeholder="状态"
              >
                <el-option label="待发送" value="pending"></el-option>
                <el-option label="发送中" value="sending"></el-option>
                <el-option label="已发送" value="sent"></el-option>
                <el-option label="失败" value="failed"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="notificationQuery.keyword"
                placeholder="客户、错误信息"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="站点">
              <el-select
                v-model="notificationQuery.site_id"
                class="site-select"
                filterable
                clearable
                placeholder="全部站点"
              >
                <el-option label="全部站点" value=""></el-option>
                <el-option
                  v-for="site in siteOptions"
                  :key="site.id"
                  :label="siteOptionLabel(site)"
                  :value="site.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getNotifications"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
          <el-table
            v-loading="notificationsLoading"
            :data="notifications.list"
            size="small"
          >
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column
              prop="clue_id"
              label="线索ID"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="customer_name"
              label="客户"
              min-width="120"
            ></el-table-column>
            <el-table-column label="站点" min-width="220">
              <template slot-scope="{ row }">
                <div class="site-info">
                  <div class="site-name">{{ row.site_name || "-" }}</div>
                  <div class="site-url">{{ row.site_url || "-" }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="provider"
              label="通道"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100"
            ></el-table-column>
            <el-table-column label="微信返回" min-width="260">
              <template slot-scope="{ row }">
                <el-tooltip
                  v-if="
                    row.wechat_errmsg_raw &&
                    row.wechat_errmsg_raw !== row.wechat_errmsg_display
                  "
                  :content="row.wechat_errmsg_raw"
                  placement="top"
                >
                  <span class="errmsg-text">{{
                    row.wechat_errmsg_display || "-"
                  }}</span>
                </el-tooltip>
                <span v-else class="errmsg-text">{{
                  row.wechat_errmsg_display || row.wechat_errmsg || "-"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="170">
              <template slot-scope="{ row }">{{
                timeText(row.create_time)
              }}</template>
            </el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="{ row }">
                <el-button
                  v-if="
                    row.status === 'failed' &&
                    $hasPermission('setting.wechat', 'test') &&
                    Number(row.can_resend) === 1
                  "
                  type="text"
                  size="small"
                  @click="resend(row)"
                >
                  重发
                </el-button>
                <el-tooltip
                  v-else-if="
                    row.status === 'failed' &&
                    $hasPermission('setting.wechat', 'test')
                  "
                  :content="row.resend_disabled_reason || '当前通知无法重发'"
                  placement="top"
                >
                  <span>
                    <el-button type="text" size="small" disabled>
                      重发
                    </el-button>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="测试模板消息"
      :visible.sync="testDialogVisible"
      width="520px"
    >
      <el-form :model="testForm" size="small" label-width="90px">
        <el-form-item v-if="isDirectProvider" label="OpenID">
          <el-input v-model="testForm.openid"></el-input>
        </el-form-item>
        <el-form-item v-if="isBridgeProvider" label="子账户ID">
          <el-select
            v-model="testForm.customer_account_id"
            class="test-receiver-select"
            filterable
            placeholder="选择已绑定微信的子账户"
          >
            <el-option
              v-for="item in bridgeReceiverOptions"
              :key="item.optionKey"
              :label="item.label"
              :value="item.customer_account_id"
            ></el-option>
          </el-select>
          <div class="form-tips">
            中台 business_user_id =
            本系统子账户ID。只显示已绑定且已关注的接收人。
          </div>
        </el-form-item>
        <el-form-item label="跳转URL">
          <el-input
            v-model="testForm.url"
            placeholder="模板消息点击后打开的页面"
          >
            <el-button slot="append" @click="fillDefaultTestUrl">
              填入默认
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="testDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="testTemplate">
          发送
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiWechatBindings,
  apiWechatNotifications,
  apiWechatResend,
  apiWechatSaveSettings,
  apiWechatSettings,
  apiWechatTestAccessToken,
  apiWechatTestTemplate,
} from "@/api/setting";
import { apiSiteOptions } from "@/api/site";
import { formatDate } from "@/utils/util";

export default {
  data() {
    return {
      activeTab: "settings",
      settingsLoading: false,
      saving: false,
      bindingsLoading: false,
      notificationsLoading: false,
      testDialogVisible: false,
      siteOptions: [],
      form: {
        id: 0,
        name: "",
        provider: "direct_wechat",
        app_id: "",
        app_secret: "",
        app_secret_masked: "",
        token: "",
        encoding_aes_key: "",
        template_id: "",
        template_field_map: {
          remind_time: "time1",
          contact: "thing2",
          country: "thing3",
          reason: "thing4",
        },
        bridge_endpoint: "",
        bridge_app_code: "lead_system",
        bridge_app_secret: "",
        bridge_app_secret_masked: "",
        bridge_token: "",
        bridge_token_masked: "",
        status: 0,
      },
      defaultWechatAvatar:
        "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><rect width='40' height='40' rx='20' fill='%23f0f2f5'/><circle cx='20' cy='16' r='7' fill='%23c0c4cc'/><path d='M8 34c2.5-7 6.7-10 12-10s9.5 3 12 10' fill='%23c0c4cc'/></svg>",
      rules: {
        name: [
          { required: true, message: "请输入公众号名称", trigger: "blur" },
        ],
        provider: [
          { required: true, message: "请选择发送通道", trigger: "change" },
        ],
        app_id: [
          {
            validator: (rule, value, callback) => {
              if (this.isDirectProvider && !value) {
                callback(new Error("请输入AppID"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        token: [
          {
            validator: (rule, value, callback) => {
              if (this.isDirectProvider && !value) {
                callback(new Error("请输入回调Token"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        template_id: [
          { required: true, message: "请输入模板ID", trigger: "blur" },
        ],
        bridge_endpoint: [
          {
            validator: (rule, value, callback) => {
              if (this.isBridgeProvider && !value) {
                callback(new Error("请输入中转地址"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      bindingQuery: {
        keyword: "",
        site_id: "",
      },
      bindings: {
        list: [],
        count: 0,
      },
      notificationQuery: {
        status: "",
        keyword: "",
        site_id: "",
      },
      notifications: {
        list: [],
        count: 0,
      },
      testForm: {
        openid: "",
        customer_account_id: "",
        url: "",
      },
    };
  },
  created() {
    this.getSettings();
    this.getSiteOptions();
    this.getBindings();
    this.getNotifications();
  },
  computed: {
    isDirectProvider() {
      return this.form.provider === "direct_wechat";
    },
    isBridgeProvider() {
      return this.form.provider === "bridge";
    },
    bridgeReceiverOptions() {
      const receiverMap = new Map();
      (this.bindings.list || [])
        .filter(
          (item) =>
            Number(item.status) === 1 &&
            Number(item.subscribe_status) === 1 &&
            item.customer_account_id
        )
        .forEach((item) => {
          const id = item.customer_account_id;
          if (receiverMap.has(id)) {
            const existing = receiverMap.get(id);
            existing.receiverCount += 1;
            existing.label = this.bridgeReceiverLabel(existing);
            return;
          }
          const username = item.username || "-";
          const customer = item.customer_name || "-";
          const nickname = item.nickname || "微信接收人";
          const site = item.site_name || "-";
          const option = {
            ...item,
            optionKey: String(id),
            receiverCount: 1,
            username,
            customer,
            nickname,
            site,
          };
          option.label = this.bridgeReceiverLabel(option);
          receiverMap.set(id, option);
        });
      return Array.from(receiverMap.values());
    },
  },
  methods: {
    getSettings() {
      this.settingsLoading = true;
      apiWechatSettings()
        .then((resp) => {
          this.form = {
            ...this.form,
            ...resp,
            app_secret: "",
            bridge_app_secret: "",
            bridge_token: "",
            template_field_map: {
              ...this.form.template_field_map,
              ...(resp.template_field_map || {}),
            },
          };
        })
        .finally(() => {
          this.settingsLoading = false;
        });
    },
    saveSettings() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        apiWechatSaveSettings(this.form)
          .then(() => {
            this.$message.success("保存成功");
            this.getSettings();
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    testToken() {
      apiWechatTestAccessToken().then((resp) => {
        this.$message.success(`检测通过：${resp.access_token_masked}`);
      });
    },
    openTestDialog() {
      this.fillDefaultTestUrl();
      if (this.isBridgeProvider) {
        this.getBindings().then(() => {
          this.fillFirstBridgeReceiver();
        });
        this.fillFirstBridgeReceiver();
      }
      this.testDialogVisible = true;
    },
    fillDefaultTestUrl() {
      this.testForm.url = `${window.location.origin}/manage-admin/#/clue/list`;
    },
    bridgeReceiverLabel(item) {
      const suffix =
        item.receiverCount > 1 ? ` / ${item.receiverCount}个接收人` : "";
      return `${item.customer_account_id} - ${item.username} / ${item.customer} / ${item.nickname} / ${item.site}${suffix}`;
    },
    fillFirstBridgeReceiver() {
      if (this.testForm.customer_account_id) return;
      const first = this.bridgeReceiverOptions[0];
      if (first) {
        this.testForm.customer_account_id = first.customer_account_id;
      }
    },
    testTemplate() {
      if (this.isBridgeProvider && !this.testForm.customer_account_id) {
        this.$message.warning("请选择已绑定微信的子账户");
        return;
      }
      apiWechatTestTemplate(this.testForm).then(() => {
        this.$message.success("测试消息已发送");
        this.testDialogVisible = false;
      });
    },
    getSiteOptions() {
      apiSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    siteOptionLabel(site) {
      const name = site.name || "-";
      const url = site.url || "-";
      return `${name} ${url}`;
    },
    getBindings() {
      this.bindingsLoading = true;
      return apiWechatBindings(this.bindingQuery)
        .then((resp) => {
          this.bindings = resp;
        })
        .finally(() => {
          this.bindingsLoading = false;
        });
    },
    getNotifications() {
      this.notificationsLoading = true;
      apiWechatNotifications(this.notificationQuery)
        .then((resp) => {
          this.notifications = resp;
        })
        .finally(() => {
          this.notificationsLoading = false;
        });
    },
    resend(row) {
      apiWechatResend({ id: row.id }).then(() => {
        this.$message.success("已加入重发");
        this.getNotifications();
      });
    },
    timeText(value) {
      return value ? formatDate(value, "yyyy-mm-dd hh:MM:ss") : "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  width: 520px;
  max-width: 100%;
}

.form-tips {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.field-map {
  max-width: 920px;
}

.site-select {
  width: 420px;
  max-width: 100%;
}

.test-receiver-select {
  width: 100%;
}

.actions {
  padding-left: 150px;
}

.site-info {
  line-height: 1.5;
}

.site-name {
  color: #303133;
  font-weight: 500;
}

.site-url {
  color: #909399;
  font-size: 12px;
  word-break: break-all;
}

.wechat-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wechat-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  background: #f0f2f5;
  flex: 0 0 auto;
}

.wechat-name {
  color: #303133;
  font-weight: 500;
  line-height: 1.4;
}

.wechat-openid {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

.errmsg-text {
  color: #606266;
  line-height: 1.5;
}
</style>
